// src/components/UserTopBar.js
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NotificationBell from "./NotificationBell";
import { motion, AnimatePresence } from "framer-motion";

export default function UserTopBar() {
  const { authUser, logout } = useAuth();
  const [open, setOpen] = useState(false);

  const avatar = authUser?.user?.avatar;
  const letter = authUser?.user?.name?.charAt(0)?.toUpperCase() || "U";

  return (
    <div className="flex justify-end items-center gap-4 px-4 py-3 border-b border-white/10 bg-black/30 backdrop-blur-xl">
      <NotificationBell />

      <div
        onClick={() => setOpen(!open)}
        className="cursor-pointer w-10 h-10 rounded-full bg-purple-600 overflow-hidden flex items-center justify-center"
      >
        {avatar ? (
          <img src={avatar} alt="avatar" className="w-full h-full object-cover" />
        ) : (
          <span className="font-bold">{letter}</span>
        )}
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            className="absolute right-4 top-16 w-52 bg-[#14192a] border border-white/10 rounded-xl shadow-xl p-3 z-50"
          >
            <Link to="/settings" className="block p-2 rounded hover:bg-white/10">
              Profile & Settings
            </Link>
            <Link to="/wallet" className="block p-2 rounded hover:bg-white/10">
              Wallet
            </Link>
            <Link to="/orders" className="block p-2 rounded hover:bg-white/10">
              Orders
            </Link>
            <button
              onClick={logout}
              className="w-full mt-2 p-2 text-left bg-red-500/20 hover:bg-red-500/40 text-red-300 rounded"
            >
              Logout
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
